<script setup>
import { useAppStore } from '@/store/app';

const appStore = useAppStore();

watch(
	() => appStore.title,
	() => {
		document.title = appStore.title;
	},
);
</script>

<template>
	<slot />
</template>
